import React, { memo, useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'

import { TABLE_REPORTE_POR_SILOS } from '../../../../../config/tables'
import { parseDataParaTablaPorSilos } from '../../../../../models/movimiento/movimientoUtils'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'
import { updateMuiTable } from '../../../../MuiTable/actions'
import { COLUMNS_TABLA_SILOS, COLUMNS_TABLA_SILOS_TO_PRINT } from '../actions/constantesTablaSilo'
import { TablaReportePorSilosView } from '../components/TablaReportePorSilosView'

const silosParaTabla = createSelector(silos => silos, (silos) => parseDataParaTablaPorSilos(silos))

const mapStateToProps = (state) => ({
  loading: state.movimientos.estadoSilos.loading,
  silos: silosParaTabla(state.movimientos.estadoSilos.silos)
})

export const TablaReportePorSilos = connect(mapStateToProps, { updateMuiTable })(
  memo(({ updateMuiTable, loading, silos }) => {
    const customToolbar = useMemo(() => pdfCustomToolbarGenerator('Reporte Estado Por Silos', silos, COLUMNS_TABLA_SILOS_TO_PRINT, 'landscape'), [silos])
    useEffect(() => {
      updateMuiTable(TABLE_REPORTE_POR_SILOS, {
        columns: COLUMNS_TABLA_SILOS,
        data: silos,
        title: `Reporte Estado Por Silos`,
        isLoading: loading,
        fixed2Decimales: true,
        extraOptions: {
          customToolbar,
          print: false
        }
      })
    }, [updateMuiTable, loading, silos, customToolbar])
    return <TablaReportePorSilosView />
  })
)
